export default __webpack_public_path__ + "static/media/burger2.66e8af51.jpg";